export const videos_es = [
  {
    id: 1,
    category_name: "Gaming Tips Video",
    data: [
      {
        id: 1,
        title: "Spider-Man - 9 Things Before Playing",
        images_url:
          "http://cdn.game-lords.com/Batch+2/es-video/Spider-Man+-+9+Things+Before+Playing.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/es-video/Spider-Man+-+9+Things+Before+Playing.mp4",
      },
      {
        id: 2,
        title: "Far Cry 5 - 10 Tips & Tricks The Game Doesn't Tell You",
        images_url:
          "http://cdn.game-lords.com/Batch+2/es-video/Far+Cry+5+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/es-video/Far+Cry+5+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.mp4",
      },
      {
        id: 3,
        title: "God Of War - 10 Tips & Tricks The Game Doesn't Tell You",
        images_url:
          "http://cdn.game-lords.com/Batch+2/es-video/God+Of+War+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/es-video/God+Of+War+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.mp4",
      },
      {
        id: 4,
        title: "PUBG Mobile - 10 Tips & Tricks The Game Doesn't Tell You",
        images_url:
          "http://cdn.game-lords.com/Batch+2/es-video/PUBG+Mobile+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/es-video/PUBG+Mobile+-+10+Tips+%26+Tricks+The+Game+Doesn't+Tell+You.mp4",
      },
      {
        id: 5,
        title: "Top 10 Beginner Fortnite Battle Royale Tips",
        images_url:
          "http://cdn.game-lords.com/Batch+2/es-video/Top+10+Beginner+Fortnite+Battle+Royale+Tips.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/es-video/Top+10+Beginner+Fortnite+Battle+Royale+Tips.mp4",
      },
    ],
  },
];

export const videos_za_ci = [
  {
    id: 1,
    category_name: "Sports Betting Tips & Tricks",
    data: [
      {
        id: 1,
        title: "3 Football Betting Strategies",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/3+Football+Betting+Strategies.png",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/3+Football+Betting+Strategies.mp4",
      },
      {
        id: 2,
        title: "10 Sports Betting Tips",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/10+Sports+Betting+Tips.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/10+Sports+Betting+Tips.mp4",
      },
      {
        id: 3,
        title: "Betting Strategy That Works",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Betting+Strategy+That+Works.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Betting+Strategy+That+Works.mp4",
      },
      {
        id: 4,
        title: "Football betting tips and tricks",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Football+betting+tips+and+tricks.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Football+betting+tips+and+tricks.mp4",
      },
      {
        id: 5,
        title: "Sports Betting Tips for 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Sports+Betting+Tips+for+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Sports+Betting+Tips+for+2021.mp4",
      },
      {
        id: 6,
        title: "Tricks to Win Football Betting",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Tricks+to+Win+Football+Betting.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Sports+Betting+Tips+%26+Tricks/Tricks+to+Win+Football+Betting.mp4",
      },
    ],
  },
];

export const videos_no = [
  {
    id: 1,
    category_name: "Coin Master Tutorial",
    data: [
      {
        id: 1,
        title: "Coin Master - How To Get Unlimited Coin Master Spins",
        images_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Get+Unlimited+Coin+Master+Spins.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Get+Unlimited+Coin+Master+Spins.mp4",
      },
      {
        id: 2,
        title: "Coin Master - How To Not Get Attacked",
        images_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Not+Get+Attacked.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+How+To+Not+Get+Attacked.mp4",
      },
      {
        id: 3,
        title: "Coin Master - Spins & Coins Cheats",
        images_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Spins+%26+Coins+Cheats.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Spins+%26+Coins+Cheats.mp4",
      },
      {
        id: 4,
        title: "Coin Master - Tips & Tricks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Tips+%26+Tricks.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Tips+%26+Tricks.mp4",
      },
      {
        id: 5,
        title: "Coin Master - Full Bet Playing Blast into Space Event",
        images_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Full+Bet+Playing+Blast+into+Space+Event.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/no-video/Coin+Master+-+Full+Bet+Playing+Blast+into+Space+Event.mp4",
      },
    ],
  },
];

export const videos_kw = [
  {
    id: 1,
    category_name: "Games Trailers",
    data: [
      {
        id: 1,
        title: "Assault Fury Mission Combat",
        images_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Assault+Fury+Mission+Combat.JPG",
        video_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Assault+Fury+Mission+Combat.mp4",
      },
      {
        id: 2,
        title: "Bazooka Gunner War Strike 3D",
        images_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Bazooka+Gunner+War+Strike+3D.JPG",
        video_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Bazooka+Gunner+War+Strike+3D.mp4",
      },
      {
        id: 3,
        title: "Hill Truck Driver Off Road",
        images_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Hill+Truck+Driver+Off+Road.JPG",
        video_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Hill+Truck+Driver+Off+Road.mp4",
      },
      {
        id: 4,
        title: "Jail Prison Break 2018",
        images_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Jail+Prison+Break+2018.JPG",
        video_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Jail+Prison+Break+2018.mp4",
      },
      {
        id: 5,
        title: "Konan Survival Barbarian Exile",
        images_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Konan+Survival+Barbarian+Exile.JPG",
        video_url:
          "http://cdn.game-lords.com/Batch+2/kw-video/Konan+Survival+Barbarian+Exile.mp4",
      },
    ],
  },
  {
    id: 2,
    category_name: "Among Us Tips & Tricks",
    data: [
      {
        id: 6,
        title: "50 Tips for Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.mp4",
      },
      {
        id: 7,
        title: "HOW TO ALWAYS WIN AS IMPOSTOR IN AMONG US!!!",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.mp4",
      },
      {
        id: 8,
        title: "Top 10 Tips & Tricks in Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.mp4",
      },
      {
        id: 9,
        title: "Top 15 Tips & Tricks in Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.mp4",
      },
      {
        id: 10,
        title: "Top 15 Tips & Tricks in Among Us #2",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.mp4",
      },
      {
        id: 11,
        title:
          "Top 20 Impostor Tips and Tricks in Among Us - How to Be a Pro Impostor",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.mp4",
      },
      {
        id: 12,
        title:
          "Top 50 Tips & Tricks in Among Us Compilation   Ultimate Guide To Become a Pro",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.mp4",
      },
    ],
  },
  {
    id: 3,
    category_name: "Tiktok Tips & Tricks",
    data: [
      {
        id: 13,
        title: "How to get started on TikTok Tips and Tricks for 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4",
      },
      {
        id: 14,
        title: "How To Skyrocket TikTok GROWTH in 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4",
      },
      {
        id: 15,
        title: "Tiktok Mistakes To STOP Doing in 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4",
      },
      {
        id: 16,
        title: "Tips To Grow FASTER on TikTok",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4",
      },
    ],
  },
];

export const videos_qa = [
  {
    id: 1,
    category_name: "Cyberpunk 2077 Tips & Tricks",
    data: [
      {
        id: 1,
        title: "Cyberpunk 2077 - 8 Huge Mistakes You're Doing Right Now!",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.mp4",
      },
      {
        id: 2,
        title: "Cyberpunk 2077 - Best Secret Legendary Items",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.mp4",
      },
      {
        id: 3,
        title: "Cyberpunk 2077 - Crazy Powerful Hidden Weapons",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.mp4",
      },
      {
        id: 4,
        title: "Cyberpunk 2077 – Before You Build Your Character",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.mp4",
      },
      {
        id: 5,
        title: "Cyberpunk 2077 Advanced Gameplay Tips",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.mp4",
      },
      {
        id: 6,
        title: "Ultimate Guide to The World of Cyberpunk 2077",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.mp4",
      },
    ],
  },
  {
    id: 2,
    category_name: "Among Us Tips & Tricks",
    data: [
      {
        id: 7,
        title: "50 Tips for Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.mp4",
      },
      {
        id: 8,
        title: "HOW TO ALWAYS WIN AS IMPOSTOR IN AMONG US!!!",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.mp4",
      },
      {
        id: 9,
        title: "Top 10 Tips & Tricks in Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.mp4",
      },
      {
        id: 10,
        title: "Top 15 Tips & Tricks in Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.mp4",
      },
      {
        id: 11,
        title: "Top 15 Tips & Tricks in Among Us #2",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.mp4",
      },
      {
        id: 12,
        title:
          "Top 20 Impostor Tips and Tricks in Among Us - How to Be a Pro Impostor",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.mp4",
      },
      {
        id: 13,
        title:
          "Top 50 Tips & Tricks in Among Us Compilation   Ultimate Guide To Become a Pro",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.mp4",
      },
    ],
  },
  {
    id: 3,
    category_name: "Fall Guys Tips & Tricks",
    data: [
      {
        id: 14,
        title: "Fall Guys - Ultimate Guide - How To Win Every Round",
        images_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.jpg",
        video_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.mp4",
      },
      {
        id: 15,
        title: "Fall Guys Ultimate Tips and Tricks",
        images_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.jpg",
        video_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.mp4",
      },
      {
        id: 16,
        title: "How To Win Every Level In Fall Guys",
        images_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.jpg",
        video_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.mp4",
      },
    ],
  },
  {
    id: 4,
    category_name: "Tiktok Tips & Tricks",
    data: [
      {
        id: 17,
        title: "How to get started on TikTok Tips and Tricks for 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4",
      },
      {
        id: 18,
        title: "How To Skyrocket TikTok GROWTH in 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4",
      },
      {
        id: 19,
        title: "Tiktok Mistakes To STOP Doing in 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4",
      },
      {
        id: 20,
        title: "Tips To Grow FASTER on TikTok",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4",
      },
    ],
  },
];

export const videos_ae = [
  {
    id: 1,
    category_name: "Cyberpunk 2077 Tips & Tricks",
    data: [
      {
        id: 1,
        title: "Cyberpunk 2077 - 8 Huge Mistakes You're Doing Right Now!",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.mp4",
      },
      {
        id: 2,
        title: "Cyberpunk 2077 - Best Secret Legendary Items",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.mp4",
      },
      {
        id: 3,
        title: "Cyberpunk 2077 - Crazy Powerful Hidden Weapons",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.mp4",
      },
      {
        id: 4,
        title: "Cyberpunk 2077 – Before You Build Your Character",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.mp4",
      },
      {
        id: 5,
        title: "Cyberpunk 2077 Advanced Gameplay Tips",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.mp4",
      },
      {
        id: 6,
        title: "Ultimate Guide to The World of Cyberpunk 2077",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.mp4",
      },
    ],
  },
  {
    id: 2,
    category_name: "Among Us Tips & Tricks",
    data: [
      {
        id: 7,
        title: "50 Tips for Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/50+Tips+for+Among+Us.mp4",
      },
      {
        id: 8,
        title: "HOW TO ALWAYS WIN AS IMPOSTOR IN AMONG US!!!",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/HOW+TO+ALWAYS+WIN+AS+IMPOSTOR+IN+AMONG+US!!!.mp4",
      },
      {
        id: 9,
        title: "Top 10 Tips & Tricks in Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+10+Tips+%26+Tricks+in+Among+Us.mp4",
      },
      {
        id: 10,
        title: "Top 15 Tips & Tricks in Among Us",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us.mp4",
      },
      {
        id: 11,
        title: "Top 15 Tips & Tricks in Among Us #2",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+15+Tips+%26+Tricks+in+Among+Us+%232.mp4",
      },
      {
        id: 12,
        title:
          "Top 20 Impostor Tips and Tricks in Among Us - How to Be a Pro Impostor",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+20+Impostor+Tips+and+Tricks+in+Among+Us+-+How+to+Be+a+Pro+Impostor.mp4",
      },
      {
        id: 13,
        title:
          "Top 50 Tips & Tricks in Among Us Compilation   Ultimate Guide To Become a Pro",
        images_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/Among+Us+Tips+%26+Tricks/Top+50+Tips+%26+Tricks+in+Among+Us+Compilation+++Ultimate+Guide+To+Become+a+Pro.mp4",
      },
    ],
  },
  {
    id: 3,
    category_name: "Tiktok Tips & Tricks",
    data: [
      {
        id: 1,
        title: "How to get started on TikTok Tips and Tricks for 2021",
        images_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
        video_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4",
      },
      {
        id: 2,
        title: "How To Skyrocket TikTok GROWTH in 2021",
        images_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
        video_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4",
      },
      {
        id: 3,
        title: "Tiktok Mistakes To STOP Doing in 2021",
        images_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
        video_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4",
      },
      {
        id: 4,
        title: "Tips To Grow FASTER on TikTok",
        images_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
        video_url:
          "https://gamiclub-content.s3-eu-west-1.amazonaws.com/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4",
      },
    ],
  },
];

export const videos_eg = [
  {
    id: 1,
    category_name: "نصائح وحيل Fall Guys",
    data: [
      {
        id: 1,
        title: "Fall Guys - الدليل النهائي - كيف تربح كل جولة",
        images_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.jpg",
        video_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+-+Ultimate+Guide+-+How+To+Win+Every+Round.mp4",
      },
      {
        id: 2,
        title: "نصائح وحيل Fall Guys Ultimate",
        images_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.jpg",
        video_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/Fall+Guys+Ultimate+Tips+and+Tricks.mp4",
      },
      {
        id: 3,
        title: "كيف تربح كل المستويات في Fall Guys",
        images_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.jpg",
        video_url:
          "https://cdn.mobiotv.com/tr/Fall+Guys+Tips+%26+Tricks/How+To+Win+Every+Level+In+Fall+Guys.mp4",
      },
    ],
  },
];

export const videos_rs = [
  {
    id: 1,
    category_name: "Cyberpunk 2077 - САВЕТИ",
    data: [
      {
        id: 1,
        title: "Cyberpunk 2077 - 8 Huge Mistakes You're Doing Right Now!",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+8+Huge+Mistakes+You're+Doing+Right+Now!.mp4",
      },
      {
        id: 2,
        title: "Cyberpunk 2077 - Best Secret Legendary Items",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Best+Secret+Legendary+Items.mp4",
      },
      {
        id: 3,
        title: "Cyberpunk 2077 - Crazy Powerful Hidden Weapons",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+-+Crazy+Powerful+Hidden+Weapons.mp4",
      },
      {
        id: 4,
        title: "Cyberpunk 2077 – Before You Build Your Character",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+%E2%80%93+Before+You+Build+Your+Character.mp4",
      },
      {
        id: 5,
        title: "Cyberpunk 2077 Advanced Gameplay Tips",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Cyberpunk+2077+Aavanced+Gameplay+Tips.mp4",
      },
      {
        id: 6,
        title: "Ultimate Guide to The World of Cyberpunk 2077",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.jpg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Cyberpunk+2077+Tips+%26+Tricks/Ultimate+Guide+to+The+World+of+Cyberpunk+2077.mp4",
      },
    ],
  },
];

export const videos_gmn = [
  {
    id: 1,
    category_name: "Around The World",
    data: [
      {
        id: 1,
        title: "Fun Fact 1",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+1.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+1.MP4",
      },
      {
        id: 2,
        title: "Fun Fact 2",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+2.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+2.MP4",
      },
      {
        id: 3,
        title: "Fun Fact 3",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+3.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+3.MP4",
      },
      {
        id: 4,
        title: "Fun Fact 4",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+4.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+4.MP4",
      },
      {
        id: 5,
        title: "Fun Fact 5",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+5.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+5.MP4",
      },
      {
        id: 6,
        title: "Fun Fact 6",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+6.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+6.MP4",
      },
      {
        id: 7,
        title: "Fun Fact 7",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+7.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+7.MP4",
      },
      {
        id: 8,
        title: "Fun Fact 8",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+8.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+8.MP4",
      },
      {
        id: 9,
        title: "Fun Fact 9",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+9.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+9.MP4",
      },
      {
        id: 10,
        title: "Fun Fact 10",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+10.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+10.MP4",
      },
      {
        id: 11,
        title: "Fun Fact 11",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+11.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+11.MP4",
      },
      {
        id: 12,
        title: "Fun Fact 12",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+12.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+12.MP4",
      },
      {
        id: 13,
        title: "Fun Fact 13",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+13.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+13.MP4",
      },
      {
        id: 14,
        title: "Fun Fact 14",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+14.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+14.MP4",
      },
      {
        id: 15,
        title: "Fun Fact 15",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+15.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+15.MP4",
      },
      {
        id: 16,
        title: "Fun Fact 16",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+16.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+16.MP4",
      },
      {
        id: 17,
        title: "Fun Fact 17",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+17.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+17.MP4",
      },
      {
        id: 18,
        title: "Fun Fact 17",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+18.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+18.MP4",
      },
      {
        id: 19,
        title: "Fun Fact 19",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+19.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+19.MP4",
      },
      {
        id: 20,
        title: "Fun Fact 20",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+20.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+20.MP4",
      },
      {
        id: 21,
        title: "Fun Fact 21",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+21.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+21.MP4",
      },
      {
        id: 22,
        title: "Fun Fact 22",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+22.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+22.MP4",
      },
      {
        id: 23,
        title: "Fun Fact 23",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+23.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+23.MP4",
      },
      {
        id: 24,
        title: "Fun Fact 24",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+24.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+24.MP4",
      },
      {
        id: 25,
        title: "Fun Fact 25",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+25.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+25.MP4",
      },
      {
        id: 26,
        title: "Fun Fact 26",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+26.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+26.MP4",
      },
      {
        id: 27,
        title: "Fun Fact 27",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+27.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+27.MP4",
      },
      {
        id: 28,
        title: "Fun Fact 28",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+28.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+28.MP4",
      },
      {
        id: 29,
        title: "Fun Fact 29",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+29.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Around+The+World/Fun+Fact+29.MP4",
      },
    ],
  },
  {
    id: 2,
    category_name: "Basketball Best Shots",
    data: [
      {
        id: 1,
        title:
          "5 Star Basketball Camp Vol. 1 Pressure Defense with Ed Klimkowski",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/5+Star+Basketball+Camp+Vol.+1+Pressure+Defense+with+Ed+Klimkowski.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/5+Star+Basketball+Camp+Vol.+1+Pressure+Defense+with+Ed+Klimkowski.mp4",
      },
      {
        id: 2,
        title: "2015 College Slam & 3-point Sizzle",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2015+College+Slam+%26+3-point+Sizzle.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2015+College+Slam+%26+3-point+Sizzle.MP4",
      },
      {
        id: 3,
        title: "2016 State Farm Assist of the Year Champion - Kahlil Felder",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Champion+-+Kahlil+Felder.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Champion+-+Kahlil+Felder.MP4",
      },
      {
        id: 4,
        title: "2016 State Farm Assist of the Year Recap",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Recap.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Basketball+Best+Shots/2016+State+Farm+Assist+of+the+Year+Recap.MP4",
      },
    ],
  },
  {
    id: 3,
    category_name: "Best Videos",
    data: [
      {
        id: 1,
        title: "Fun Fact - Babies",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Babies.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Babies.MP4",
      },
      {
        id: 2,
        title: "Fun Fact - Dogs",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Dogs.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+Dogs.MP4",
      },
      {
        id: 3,
        title: "Fun Fact - What with Sugar",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+What+with+Sugar.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Fun+Fact+-+What+with+Sugar.MP4",
      },
      {
        id: 4,
        title: "Get It Beauty-Makeup Tip - Korean-style Natural Makeup",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Korean-style+Natural+Makeup.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Korean-style+Natural+Makeup.MP4",
      },
      {
        id: 5,
        title: "Get It Beauty-Makeup Tip - Makeup that Keeps the Moisture",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Makeup+that+Keeps+the+Moisture.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Get+It+Beauty-Makeup+Tip+-+Makeup+that+Keeps+the+Moisture.MP4",
      },
      {
        id: 6,
        title: "Health Tip - Excercise always",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tip+-+Excercise+always.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tip+-+Excercise+always.MP4",
      },
      {
        id: 7,
        title: "Health Tips - Excercise better",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tips+-+Excercise+better.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Health+Tips+-+Excercise+better.MP4",
      },
      {
        id: 8,
        title: "Nutritionist - Excercise",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Excercise.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Excercise.MP4",
      },
      {
        id: 9,
        title: "Nutritionist - Hydration",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Hydration.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Best+Videos/Nutritionist+-+Hydration.MP4",
      },
    ],
  },
  {
    id: 4,
    category_name: "Boxing & Workouts",
    data: [
      {
        id: 1,
        title: "Arm and Leg Raise",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Arm+and+Leg+Raise.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Arm+and+Leg+Raise.MP4",
      },
      {
        id: 2,
        title: "Attack and Defense",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Attack+and+Defense.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Attack+and+Defense.MP4",
      },
      {
        id: 3,
        title: "Condition training",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Condition+training.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Condition+training.MP4",
      },
      {
        id: 4,
        title: "Core strength",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Core+strength.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Core+strength.MP4",
      },
      {
        id: 5,
        title: "Lunges",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Lunges.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Lunges.MP4",
      },
      {
        id: 6,
        title: "Punch Bag",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Punch+Bag.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Punch+Bag.MP4",
      },
      {
        id: 7,
        title: "Push Ups",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Push+Ups.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Push+Ups.MP4",
      },
      {
        id: 8,
        title: "Russian Kicks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Russian+Kicks.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Russian+Kicks.MP4",
      },
      {
        id: 9,
        title: "Shadowboxing",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Shadowboxing.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Shadowboxing.MP4",
      },
      {
        id: 10,
        title: "Sit Ups",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Sit+Ups.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Sit+Ups.MP4",
      },
      {
        id: 11,
        title: "Stretching",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Stretching.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Stretching.MP4",
      },
      {
        id: 12,
        title: "The Plank",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/The+Plank.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/The+Plank.MP4",
      },
      {
        id: 13,
        title: "Tricep Dips",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Tricep+Dips.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Boxing+%26+Workouts/Tricep+Dips.MP4",
      },
    ],
  },
  {
    id: 5,
    category_name: "Chef Master",
    data: [
      {
        id: 1,
        title: "Baked Macaroni and Cheese",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Baked+Macaroni+and+Cheese.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Baked+Macaroni+and+Cheese.MP4",
      },
      {
        id: 2,
        title: "Blooming Onion",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Blooming+Onion.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Blooming+Onion.MP4",
      },
      {
        id: 3,
        title: "Borscht",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Borscht.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Borscht.MP4",
      },
      {
        id: 4,
        title: "Broccoli Salad",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Broccoli+Salad.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Broccoli+Salad.MP4",
      },
      {
        id: 5,
        title: "Buffalo Chicken Fingers",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Buffalo+Chicken+Fingers.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Buffalo+Chicken+Fingers.MP4",
      },
      {
        id: 6,
        title: "Caramelized French Toast",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Caramelized+French+Toast.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Caramelized+French+Toast.MP4",
      },
      {
        id: 7,
        title: "Cauliflower Sheep",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cauliflower+Sheep.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cauliflower+Sheep.MP4",
      },
      {
        id: 8,
        title: "Cheese Fondue",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.MP4",
      },
    ],
  },
  {
    id: 6,
    category_name: "Comedy",
    data: [
      {
        id: 1,
        title: "Cold You Hold This Please",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Cold+You+Hold+This+Please.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Cold+You+Hold+This+Please.MP4",
      },
      {
        id: 2,
        title: "Flower I Love You",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Flower+I+Love+You.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Flower+I+Love+You.MP4",
      },
      {
        id: 3,
        title: "I Need Some Help Please",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/I+Need+Some+Help+Please.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/I+Need+Some+Help+Please.MP4",
      },
      {
        id: 4,
        title: "Please Try Your Facial",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Try+Your+Facial.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Try+Your+Facial.MP4",
      },
      {
        id: 5,
        title: "Please Watch And Be Careful",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.MP4",
      },
      {
        id: 6,
        title: "Please Watch And Be Careful",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/Please+Watch+And+Be+Careful.MP4",
      },
      {
        id: 7,
        title: "That Way What Wrong",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/That+Way+What+Wrong.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Comedy/That+Way+What+Wrong.MP4",
      },
      {
        id: 8,
        title: "Cheese Fondue",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Chef+Master/Cheese+Fondue.MP4",
      },
    ],
  },
  {
    id: 7,
    category_name: "Did You Know...",
    data: [
      {
        id: 1,
        title: "5 facts on our inner voice",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../5+facts+on+our+inner+voice.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../5+facts+on+our+inner+voice.MP4",
      },
      {
        id: 2,
        title: "2000 year old discoveries",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../2000+year+old+discoveries.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../2000+year+old+discoveries.MP4",
      },
      {
        id: 3,
        title: "Cool Robot",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cool+Robot.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cool+Robot.MP4",
      },
      {
        id: 4,
        title: "Cost of cyberattacks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cost+of+cyberattacks.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Cost+of+cyberattacks.MP4",
      },
      {
        id: 5,
        title: "Ditch the doctor",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Ditch+the+doctor.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Ditch+the+doctor.MP4",
      },
      {
        id: 6,
        title: "Emails dont solve paper probs",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Emails+dont+solve+paper+probs.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Emails+dont+solve+paper+probs.MP4",
      },
      {
        id: 7,
        title: "Flying drinks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Flying+drinks.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Flying+drinks.MP4",
      },
      {
        id: 8,
        title: "Looking younger",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Looking+younger.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Looking+younger.MP4",
      },
      {
        id: 9,
        title: "Nano chip",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Nano+chip.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Nano+chip.MP4",
      },
      {
        id: 10,
        title: "Obesity pandemic",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Obesity+pandemic.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Obesity+pandemic.MP4",
      },
      {
        id: 11,
        title: "Star Wars becomes reality",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Star+Wars+becomes+reality.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Star+Wars+becomes+reality.MP4",
      },
      {
        id: 12,
        title: "UK Drone Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../UK+Drone+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../UK+Drone+Show.MP4",
      },
      {
        id: 13,
        title: "VR Running of the Bulls!",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../VR+Running+of+the+Bulls!.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../VR+Running+of+the+Bulls!.MP4",
      },
      {
        id: 14,
        title: "Why are the Dutch so tall",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Why+are+the+Dutch+so+tall.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../Why+are+the+Dutch+so+tall.MP4",
      },
      {
        id: 15,
        title: "World of drone racing",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../World+of+drone+racing.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../World+of+drone+racing.MP4",
      },
    ],
  },
  {
    id: 8,
    category_name: "Football Clips",
    data: [
      {
        id: 1,
        title: "Wayne Rooney",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Did+You+Know.../5+facts+on+our+inner+voice.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wayne+Rooney.MP4",
      },
      {
        id: 2,
        title: "Will Smith Penalty",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Will+Smith+Penalty.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Will+Smith+Penalty.MP4",
      },
      {
        id: 3,
        title: "Wonderful Goal",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goal.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goal.MP4",
      },
      {
        id: 4,
        title: "Wonderful Goals",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goals.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Wonderful+Goals.MP4",
      },
      {
        id: 5,
        title: "Zinedine Zidane",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Zinedine+Zidane.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Football+Clips/Zinedine+Zidane.MP4",
      },
    ],
  },
  {
    id: 9,
    category_name: "IOS 14 Tips and Tricks",
    data: [
      {
        id: 1,
        title: "IOS 14 Tips And Tricks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/IOS+14+Tips+And+Tricks/IOS+14+Tips+and+Tricks.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/IOS+14+Tips+And+Tricks/IOS+14+Tips+and+Tricks.MP4",
      },
    ],
  },
  {
    id: 10,
    category_name: "Latest Video",
    data: [
      {
        id: 1,
        title: "5 Make up tips and Tricks for you",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/IOS+14+Tips+And+Tricks/IOS+14+Tips+and+Tricks.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/5+Make+up+tips+and+Tricks+for+you.MP4",
      },
      {
        id: 2,
        title: "7 Make up tips and tricks for flawless skin",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/7+Make+up+tips+and+tricks+for+flawless+skin.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/7+Make+up+tips+and+tricks+for+flawless+skin.MP4",
      },
      {
        id: 3,
        title: "2016 Chevrolet Camaro SS",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Chevrolet+Camaro+SS.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Chevrolet+Camaro+SS.MP4",
      },
      {
        id: 4,
        title: "2016 Ford Mustang Fastback",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Ford+Mustang+Fastback.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/2016+Ford+Mustang+Fastback.MP4",
      },
      {
        id: 5,
        title: "Angry Bull",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Angry+Bull.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Angry+Bull.MP4",
      },
      {
        id: 6,
        title: "Animals Exoticos",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Animals+Exoticos.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Animals+Exoticos.MP4",
      },
      {
        id: 7,
        title: "Arm and Leg Raise",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.MP4",
      },
      {
        id: 8,
        title: "Attack and Defense",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Attack+and+Defense.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Attack+and+Defense.MP4",
      },
      {
        id: 9,
        title: "Best Rugby Skills - Steps, Tricks, Offloads Compilation",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+-+Steps%2C+Tricks%2C+Offloads+Compilation.MP4",
      },
      {
        id: 10,
        title: "Best Rugby Skills 2018",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+2018.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Best+Rugby+Skills+2018.MP4",
      },
      {
        id: 11,
        title: "Channeled message from your spirit guides",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Channeled+message+from+your+spirit+guides.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Channeled+message+from+your+spirit+guides.MP4",
      },
      {
        id: 12,
        title: "Coaches Clinic  Pete Herrman",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Coaches+Clinic++Pete+Herrman.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Coaches+Clinic++Pete+Herrman.MP4",
      },
      {
        id: 13,
        title: "Ditch the doctor How about diagnosis by computer",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Ditch+the+doctor+How+about+diagnosis+by+computer.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Ditch+the+doctor+How+about+diagnosis+by+computer.MP4",
      },
      {
        id: 14,
        title: "Dribble Drive Motion Skills",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Dribble+Drive+Motion+Skills.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Dribble+Drive+Motion+Skills.MP4",
      },
      {
        id: 15,
        title: "ESPN s new deal dives into the world of drone racing",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.MP4",
      },
      {
        id: 16,
        title: "HOW & WHEN You Will You Become SUCCESSFUL",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/HOW+%26+WHEN+You+Will+You+Become+SUCCESSFUL.MP4",
      },
      {
        id: 17,
        title: "How to Post Natal Yoga  Breathing Exercise",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Breathing+Exercise.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Breathing+Exercise.MP4",
      },
      {
        id: 18,
        title: "How to Post Natal Yoga  Chair Exercises",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Chair+Exercises.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/How+to+Post+Natal+Yoga++Chair+Exercises.MP4",
      },
    ],
  },
  {
    id: 11,
    category_name: "Make Up Tutorial",
    data: [
      {
        id: 1,
        title: "3CE Falling in fall makeup tutorial",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/3CE+Falling+in+fall+makeup+tutorial.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/3CE+Falling+in+fall+makeup+tutorial.MP4",
      },
      {
        id: 2,
        title: "5 Makeup Tips for Beginners",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+for+Beginners.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+for+Beginners.MP4",
      },
      {
        id: 3,
        title: "5 Makeup Tips You Need To Know",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+You+Need+To+Know.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tips+You+Need+To+Know.MP4",
      },
      {
        id: 4,
        title: "5 Makeup Tricks for Beginners - Makeup Geek",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tricks+for+Beginners+-+Makeup+Geek.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/5+Makeup+Tricks+for+Beginners+-+Makeup+Geek.MP4",
      },
      {
        id: 5,
        title: "6 Makeup Tricks Every Girl Needs To Know",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/6+Makeup+Tricks+Every+Girl+Needs+To+Know.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/6+Makeup+Tricks+Every+Girl+Needs+To+Know.MP4",
      },
      {
        id: 6,
        title: "7 Makeup Tips & Tricks For A Flawless Face",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/7+Makeup+Tips+%26+Tricks+For+A+Flawless+Face.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/7+Makeup+Tips+%26+Tricks+For+A+Flawless+Face.MP4",
      },
      {
        id: 7,
        title: "Arm and Leg Raise",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Latest+Video/Arm+and+Leg+Raise.MP4",
      },
      {
        id: 8,
        title: "8 Melt-Proof Makeup Tips for Summer",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/8+Melt-Proof+Makeup+Tips+for+Summer.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/8+Melt-Proof+Makeup+Tips+for+Summer.MP4",
      },
      {
        id: 9,
        title: "10 Essential Makeup Tips For Dark Skin Tones  Beauty Junkie",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Essential+Makeup+Tips+For+Dark+Skin+Tones++Beauty+Junkie.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Essential+Makeup+Tips+For+Dark+Skin+Tones++Beauty+Junkie.MP4",
      },
      {
        id: 10,
        title: "10 Fast & Easy Makeup Tips",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Fast+%26+Easy+Makeup+Tips.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Fast+%26+Easy+Makeup+Tips.MP4",
      },
      {
        id: 11,
        title: "10 Makeup Tips for Oily Skin",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Makeup+Tips+for+Oily+Skin.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/10+Makeup+Tips+for+Oily+Skin.MP4",
      },
      {
        id: 12,
        title: "Beginner Eye Makeup Tips & Tricks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Eye+Makeup+Tips+%26+Tricks.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Eye+Makeup+Tips+%26+Tricks.MP4",
      },
      {
        id: 13,
        title: "Beginner Makeup Tips & Starter Kit  Drugstore Faves",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Starter+Kit++Drugstore+Faves.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Starter+Kit++Drugstore+Faves.MP4",
      },
      {
        id: 14,
        title: "Beginner Makeup Tips & Tricks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Tricks.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Beginner+Makeup+Tips+%26+Tricks.MP4",
      },
      {
        id: 15,
        title: "How To Apply Eyeshadow For Beginners  Makeup Tips And Tricks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Eyeshadow+For+Beginners++Makeup+Tips+And+Tricks.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Eyeshadow+For+Beginners++Makeup+Tips+And+Tricks.MP4",
      },
      {
        id: 16,
        title:
          "How To Apply Foundation For Full Coverage  Foundation Routine And Makeup Tips",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Foundation+For+Full+Coverage++Foundation+Routine+And+Makeup+Tips.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/How+To+Apply+Foundation+For+Full+Coverage++Foundation+Routine+And+Makeup+Tips.MP4",
      },
      {
        id: 17,
        title: "Korean style natural makeup",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Korean+style+natural+makeup.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Korean+style+natural+makeup.MP4",
      },
      {
        id: 18,
        title: "Makeup Mistakes to Avoid - Tips for a Flawless Face",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Mistakes+to+Avoid+-+Tips+for+a+Flawless+Face.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Mistakes+to+Avoid+-+Tips+for+a+Flawless+Face.MP4",
      },
      {
        id: 19,
        title: "Makeup MISTAKES to AVOID! - 13 Tips for a Flawless Face",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+MISTAKES+to+AVOID!+-+13+Tips+for+a+Flawless+Face.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+MISTAKES+to+AVOID!+-+13+Tips+for+a+Flawless+Face.MP4",
      },
      {
        id: 20,
        title: "Makeup that keeps the moisture",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+that+keeps+the+moisture.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+that+keeps+the+moisture.MP4",
      },
      {
        id: 21,
        title: "Makeup Tips and Tricks for Aging Eyes - Sephora",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Tips+and+Tricks+for+Aging+Eyes+-+Sephora.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Makeup+Tips+and+Tricks+for+Aging+Eyes+-+Sephora.MP4",
      },
      {
        id: 22,
        title:
          "Most Flattering Eye Makeup For Your Eye Shape  NewBeauty Tips and Tutorials",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Most+Flattering+Eye+Makeup+For+Your+Eye+Shape++NewBeauty+Tips+and+Tutorials.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Most+Flattering+Eye+Makeup+For+Your+Eye+Shape++NewBeauty+Tips+and+Tutorials.MP4",
      },
      {
        id: 23,
        title: "Natural Makeup Tips For Men",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+Makeup+Tips+For+Men.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+Makeup+Tips+For+Men.MP4",
      },
      {
        id: 24,
        title: "Natural makeup tutorial korean style - Quick Everyday Makeup",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+makeup+tutorial+korean+style+-+Quick+Everyday+Makeup.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Natural+makeup+tutorial+korean+style+-+Quick+Everyday+Makeup.MP4",
      },
      {
        id: 25,
        title: "Over 40 makeup tips- under eyes",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Over+40+makeup+tips-+under+eyes.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Over+40+makeup+tips-+under+eyes.MP4",
      },
      {
        id: 26,
        title: "Pro Makeup Artist Tips - Tip Tuesday",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Pro+Makeup+Artist+Tips+-+Tip+Tuesday.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Pro+Makeup+Artist+Tips+-+Tip+Tuesday.MP4",
      },
      {
        id: 27,
        title: "Saundarya - Make Up Tips - Introduction To The Make Up Kit",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Saundarya+-+Make+Up+Tips+-+Introduction+To+The+Make+Up+Kit.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Saundarya+-+Make+Up+Tips+-+Introduction+To+The+Make+Up+Kit.MP4",
      },
      {
        id: 28,
        title: "Summer Essentials  Easy Makeup And Beauty Tips For Summer",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Summer+Essentials++Easy+Makeup+And+Beauty+Tips+For+Summer.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Summer+Essentials++Easy+Makeup+And+Beauty+Tips+For+Summer.MP4",
      },
      {
        id: 29,
        title:
          "The Best Foundation Tips For Oily Skin For Longer Lasting Makeup",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Foundation+Tips+For+Oily+Skin+For+Longer+Lasting+Makeup.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Foundation+Tips+For+Oily+Skin+For+Longer+Lasting+Makeup.MP4",
      },
      {
        id: 30,
        title:
          "The Best Makeup Artist Tips You Need to Know  Mixed Makeup Masters",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Makeup+Artist+Tips+You+Need+to+Know++Mixed+Makeup+Masters.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+Best+Makeup+Artist+Tips+You+Need+to+Know++Mixed+Makeup+Masters.MP4",
      },
      {
        id: 31,
        title: "The most amazing makeup tips you will ever learn",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+most+amazing+makeup+tips+you+will+ever+learn.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/The+most+amazing+makeup+tips+you+will+ever+learn.MP4",
      },
      {
        id: 32,
        title: "Top 10 Celebrity Makeup Tips",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+10+Celebrity+Makeup+Tips.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+10+Celebrity+Makeup+Tips.MP4",
      },
      {
        id: 33,
        title: "Top 25 Makeup Tips Tricks & Products for Pale Skin",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+25+Makeup+Tips+Tricks+%26+Products+for+Pale+Skin.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Top+25+Makeup+Tips+Tricks+%26+Products+for+Pale+Skin.MP4",
      },
      {
        id: 34,
        title: "Tyra Banks Shares On-the-Go Makeup Tips",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Tyra+Banks+Shares+On-the-Go+Makeup+Tips.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Make+Up+Tutorial/Tyra+Banks+Shares+On-the-Go+Makeup+Tips.MP4",
      },
    ],
  },
  {
    id: 12,
    category_name: "Master Fitness",
    data: [
      {
        id: 1,
        title: "1# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/1%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/1%23+Fitness.MP4",
      },
      {
        id: 2,
        title: "2# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/2%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/2%23+Fitness.MP4",
      },
      {
        id: 3,
        title: "3# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/3%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/3%23+Fitness.MP4",
      },
      {
        id: 4,
        title: "4# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/4%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/4%23+Fitness.MP4",
      },
      {
        id: 5,
        title: "5# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/5%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/5%23+Fitness.MP4",
      },
      {
        id: 6,
        title: "6# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/6%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/6%23+Fitness.MP4",
      },
      {
        id: 7,
        title: "7# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/7%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/7%23+Fitness.MP4",
      },
      {
        id: 8,
        title: "8# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/8%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/8%23+Fitness.MP4",
      },
      {
        id: 9,
        title: "9# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/9%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/9%23+Fitness.MP4",
      },
      {
        id: 10,
        title: "10# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.MP4",
      },
      {
        id: 11,
        title: "11# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/11%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/11%23+Fitness.MP4",
      },
      {
        id: 12,
        title: "12# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/12%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/12%23+Fitness.MP4",
      },
      {
        id: 13,
        title: "13# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/13%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/13%23+Fitness.MP4",
      },
      {
        id: 14,
        title: "14# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/14%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/14%23+Fitness.MP4",
      },
      {
        id: 15,
        title: "15# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/15%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/15%23+Fitness.MP4",
      },
      {
        id: 16,
        title: "16# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/16%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/16%23+Fitness.MP4",
      },
      {
        id: 17,
        title: "17# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/17%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/17%23+Fitness.MP4",
      },
      {
        id: 18,
        title: "18# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/18%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/18%23+Fitness.MP4",
      },
    ],
  },
  {
    id: 13,
    category_name: "New Cars Ready To Roll",
    data: [
      {
        id: 1,
        title:
          "2017 Audi Q3 2.0 TDI Quattro - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+Q3+2.0+TDI+Quattro+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+Q3+2.0+TDI+Quattro+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.mp4",
      },
      {
        id: 2,
        title:
          "2017 Audi S4 Avant - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+S4+Avant+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Audi+S4+Avant+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 3,
        title:
          "2017 BMW 335d xDrive Touring M Sport - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+335d+xDrive+Touring+M+Sport+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+335d+xDrive+Touring+M+Sport+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 4,
        title:
          "2017 BMW 650i Convertible - Exterior and Interior Walkaround - 2016 Paris Auto Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+650i+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+650i+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4",
      },
      {
        id: 5,
        title:
          "2017 BMW M4 Competition Package - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M4+Competition+Package+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M4+Competition+Package+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 6,
        title:
          "2017 BMW M550d xDrive - Exterior and Interior Walkaround - 2016 Paris Auto Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M550d+xDrive+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+BMW+M550d+xDrive+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4",
      },
      {
        id: 7,
        title:
          "2017 Chavrolet Camaro LTG Auto X Concept 2.0L Turbo - Exterior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chavrolet+Camaro+LTG+Auto+X+Concept+2.0L+Turbo+-+Exterior+Walkaround+-+2016+SEMA.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chavrolet+Camaro+LTG+Auto+X+Concept+2.0L+Turbo+-+Exterior+Walkaround+-+2016+SEMA.mp4",
      },
      {
        id: 8,
        title:
          "2017 Chevrolet Corvette Grand Sport Collector Edition - Exterior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chevrolet+Corvette+Grand+Sport+Collector+Edition+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Chevrolet+Corvette+Grand+Sport+Collector+Edition+-+Exterior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 9,
        title:
          "2017 Dodge Charger Daytona - Exterior and Interior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Dodge+Charger+Daytona+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Dodge+Charger+Daytona+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 10,
        title: "10# Fitness",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Master+Fitness/10%23+Fitness.MP4",
      },
      {
        id: 11,
        title:
          "2017 Ford F150 Raptor Pre Runner by Deberti Design - Exterior and Interior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Pre+Runner+by+Deberti+Design+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Pre+Runner+by+Deberti+Design+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 12,
        title:
          "2017 Ford F150 Raptor Racing Truck by Foutz Motorsports - Exterior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Racing+Truck+by+Foutz+Motorsports+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+F150+Raptor+Racing+Truck+by+Foutz+Motorsports+-+Exterior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 13,
        title:
          "2017 Ford Mustang Fastback 825hp Carbon Fiber Body Kit by Speedkore - Exterior Walkaround 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+Mustang+Fastback+825hp+Carbon+Fiber+Body+Kit+by+Speedkore+-+Exterior+Walkaround+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Ford+Mustang+Fastback+825hp+Carbon+Fiber+Body+Kit+by+Speedkore+-+Exterior+Walkaround+2016+SEMA.MP4",
      },
      {
        id: 14,
        title:
          "2017 Honda Civic Type R Prototype - Exterior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Honda+Civic+Type+R+Prototype+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Honda+Civic+Type+R+Prototype+-+Exterior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 15,
        title:
          "2017 KIA Sorento 2.2 Diesel - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+KIA+Sorento+2.2+Diesel+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+KIA+Sorento+2.2+Diesel+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.mp4",
      },
      {
        id: 16,
        title:
          "2017 Mercedes GLS350 Diesel 4Matic - Exterior and Interior Walkaround - 2016 Paris Auto Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+GLS350+Diesel+4Matic+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+GLS350+Diesel+4Matic+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4",
      },
      {
        id: 17,
        title:
          "2017 Mercedes SL 500 - Exterior and Interior Walkaround - 2016 Paris Auto Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+SL+500+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mercedes+SL+500+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Auto+Show.MP4",
      },
      {
        id: 18,
        title:
          "2017 Mini Cooper Cabrio 136ch - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Cabrio+136ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Cabrio+136ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 19,
        title:
          "2017 Mini Cooper Clubman One 102ch - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Clubman+One+102ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mini+Cooper+Clubman+One+102ch+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 20,
        title:
          "2017 Mitsubishi L200 Double Cab Instyle 2.4 D - Exterior Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+L200+Double+Cab+Instyle+2.4+D+-+Exterior+Interior+Walkaround+-+2016+Paris+Motor+Show.jpg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+L200+Double+Cab+Instyle+2.4+D+-+Exterior+Interior+Walkaround+-+2016+Paris+Motor+Show.mp4",
      },
      {
        id: 21,
        title:
          "2017 Mitsubishi Outlander PHEV Instyle - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+Outlander+PHEV+Instyle+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Mitsubishi+Outlander+PHEV+Instyle+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 22,
        title:
          "2017 Nissan GTR with Rohan Izawa Metal Paint and Engraving - Exterior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+GTR+with+Rohan+Izawa+Metal+Paint+and+Engraving+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+GTR+with+Rohan+Izawa+Metal+Paint+and+Engraving+-+Exterior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 23,
        title:
          "2017 Nissan Micra - Exterior and Interior Walkaround Debut at 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Micra+-+Exterior+and+Interior+Walkaround+Debut+at+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Micra+-+Exterior+and+Interior+Walkaround+Debut+at+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 24,
        title:
          "2017 Nissan Navara - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Navara+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Nissan+Navara+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 25,
        title:
          "2017 Porsche 911 Turbo S Convertible - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Porsche+911+Turbo+S+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Porsche+911+Turbo+S+Convertible+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 26,
        title:
          "2017 Renault Megane GT - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Megane+GT+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Megane+GT+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 27,
        title:
          "2017 Renault Talisman Initiele - Exterior and Interior Walkaround - 2016 Paris Motor Show",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Talisman+Initiele+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Renault+Talisman+Initiele+-+Exterior+and+Interior+Walkaround+-+2016+Paris+Motor+Show.MP4",
      },
      {
        id: 28,
        title:
          "2017 Tesla Model X P90D Ludicrous by Unplugged Performance at Toyo Stand SEMA 2016 - Walkaround",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Tesla+Model+X+P90D+Ludicrous+by+Unplugged+Performance+at+Toyo+Stand+SEMA+2016+-+Walkaround.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/2017+Tesla+Model+X+P90D+Ludicrous+by+Unplugged+Performance+at+Toyo+Stand+SEMA+2016+-+Walkaround.MP4",
      },
      {
        id: 29,
        title:
          "Chevrolet Colorado ZH2 Hybrid Concept - Exterior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Chevrolet+Colorado+ZH2+Hybrid+Concept+-+Exterior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Chevrolet+Colorado+ZH2+Hybrid+Concept+-+Exterior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 30,
        title:
          "Jeep Comanche Concept - Exterior and Interior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Comanche+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Comanche+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4",
      },
      {
        id: 31,
        title:
          "Jeep Crew Chief 715 Concept - Exterior and Interior Walkaround - 2016 SEMA",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Crew+Chief+715+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/New+Cars+Ready+To+Roll/Jeep+Crew+Chief+715+Concept+-+Exterior+and+Interior+Walkaround+-+2016+SEMA.MP4",
      },
    ],
  },
  {
    id: 14,
    category_name: "Technology",
    data: [
      {
        id: 1,
        title: "2000 year old discoveries found in downtown La Paz",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/2000+year+old+discoveries+found+in+downtown+La+Paz.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/2000+year+old+discoveries+found+in+downtown+La+Paz.MP4",
      },
      {
        id: 2,
        title: "Are real diamonds really forever",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Are+real+diamonds+really+forever.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Are+real+diamonds+really+forever.MP4",
      },
      {
        id: 3,
        title: "Cardboard & home plastics make affordable prosthetics",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cardboard+%26+home+plastics+make+affordable+prosthetics.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cardboard+%26+home+plastics+make+affordable+prosthetics.MP4",
      },
      {
        id: 4,
        title: "Cowmander in Chief  This bull got milk",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cowmander+in+Chief++This+bull+got+milk.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Cowmander+in+Chief++This+bull+got+milk.MP4",
      },
      {
        id: 5,
        title: "Ditch the doctor! How about diagnosis by computer",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ditch+the+doctor!+How+about+diagnosis+by+computer.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ditch+the+doctor!+How+about+diagnosis+by+computer.MP4",
      },
      {
        id: 6,
        title: "ESPN s new deal dives into the world of drone racing",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/ESPN+s+new+deal+dives+into+the+world+of+drone+racing.MP4",
      },
      {
        id: 7,
        title: "Ever wished beer could fly Now it can!",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ever+wished+beer+could+fly+Now+it+can!.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Ever+wished+beer+could+fly+Now+it+can!.MP4",
      },
      {
        id: 8,
        title: "Hearing things Here are 5 facts on our inner voice",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Hearing+things+Here+are+5+facts+on+our+inner+voice.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Hearing+things+Here+are+5+facts+on+our+inner+voice.MP4",
      },
      {
        id: 9,
        title: "House run on human waste  The end of energy companies",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/House+run+on+human+waste++The+end+of+energy+companies.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/House+run+on+human+waste++The+end+of+energy+companies.MP4",
      },
      {
        id: 10,
        title: "Innovation  the ship that floats above the water",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Innovation++the+ship+that+floats+above+the+water.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Innovation++the+ship+that+floats+above+the+water.MP4",
      },
      {
        id: 11,
        title: "Is spotty skin the answer to looking younger",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Is+spotty+skin+the+answer+to+looking+younger.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Is+spotty+skin+the+answer+to+looking+younger.MP4",
      },
      {
        id: 12,
        title: "Just why are the Dutch so tall",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Just+why+are+the+Dutch+so+tall.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Just+why+are+the+Dutch+so+tall.MP4",
      },
      {
        id: 13,
        title: "Less ping pong a sign of market wrong in the tech world",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Less+ping+pong+a+sign+of+market+wrong+in+the+tech+world.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Less+ping+pong+a+sign+of+market+wrong+in+the+tech+world.MP4",
      },
      {
        id: 14,
        title: "Meet the robot that wants to get to know you",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Meet+the+robot+that+wants+to+get+to+know+you.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Meet+the+robot+that+wants+to+get+to+know+you.MP4",
      },
      {
        id: 15,
        title: "Mission  Kids Into Space  accomplished!",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Mission++Kids+Into+Space++accomplished!.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Mission++Kids+Into+Space++accomplished!.MP4",
      },
      {
        id: 16,
        title: "Overachiever  Sweden too good at recycling, needs trash",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Overachiever++Sweden+too+good+at+recycling%2C+needs+trash.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Overachiever++Sweden+too+good+at+recycling%2C+needs+trash.MP4",
      },
      {
        id: 17,
        title: "Proof horror films can really make you sick with sound",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Proof+horror+films+can+really+make+you+sick+with+sound.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Proof+horror+films+can+really+make+you+sick+with+sound.MP4",
      },
      {
        id: 18,
        title: "Rio s Museum of Tomorrow  A potential disaster",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Rio+s+Museum+of+Tomorrow++A+potential+disaster.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Rio+s+Museum+of+Tomorrow++A+potential+disaster.MP4",
      },
      {
        id: 20,
        title: "Should we let our kids become screen time zombies",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Should+we+let+our+kids+become+screen+time+zombies.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Should+we+let+our+kids+become+screen+time+zombies.MP4",
      },
      {
        id: 21,
        title: "Sleepover survival mode",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sleepover+survival+mode.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sleepover+survival+mode.MP4",
      },
      {
        id: 22,
        title: "Stalkers  the facts and figures on who s following you",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Stalkers++the+facts+and+figures+on+who+s+following+you.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Stalkers++the+facts+and+figures+on+who+s+following+you.MP4",
      },
      {
        id: 23,
        title: "Star Wars becomes reality in a post-apocalyptic mall",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Star+Wars+becomes+reality+in+a+post-apocalyptic+mall.MP4",
      },
      {
        id: 24,
        title: "Sugar tax  The answer to obesity pandemic",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sugar+tax++The+answer+to+obesity+pandemic.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Sugar+tax++The+answer+to+obesity+pandemic.MP4",
      },
      {
        id: 25,
        title: "Swallow this nano chip to know what s making you sick",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Swallow+this+nano+chip+to+know+what+s+making+you+sick.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Swallow+this+nano+chip+to+know+what+s+making+you+sick.MP4",
      },
      {
        id: 26,
        title: "The exploding cost of cyberattacks",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+exploding+cost+of+cyberattacks.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+exploding+cost+of+cyberattacks.MP4",
      },
      {
        id: 27,
        title: "The power of positive thinking",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+power+of+positive+thinking.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+power+of+positive+thinking.MP4",
      },
      {
        id: 28,
        title: "The science behind salted slugs",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+science+behind+salted+slugs.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/The+science+behind+salted+slugs.MP4",
      },
      {
        id: 29,
        title: "Tim Peake s blast-off to space   A life time ambition",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Tim+Peake+s+blast-off+to+space+++A+life+time+ambition.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Tim+Peake+s+blast-off+to+space+++A+life+time+ambition.MP4",
      },
      {
        id: 30,
        title: "Top 3 VR Experiences  You ll believe it when you see it",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Top+3+VR+Experiences++You+ll+believe+it+when+you+see+it.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Top+3+VR+Experiences++You+ll+believe+it+when+you+see+it.MP4",
      },
      {
        id: 31,
        title: "Turns out emails didn t solve our waste paper problems",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Turns+out+emails+didn+t+solve+our+waste+paper+problems.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Turns+out+emails+didn+t+solve+our+waste+paper+problems.MP4",
      },
      {
        id: 32,
        title: "UK Drone Show  The latest consumer industry trends",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/UK+Drone+Show++The+latest+consumer+industry+trends.png",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/UK+Drone+Show++The+latest+consumer+industry+trends.MP4",
      },
      {
        id: 33,
        title: "Whats keeping the gender balance in check",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Whats+keeping+the+gender+balance+in+check.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Whats+keeping+the+gender+balance+in+check.MP4",
      },
      {
        id: 34,
        title: "Will half the Chinese male population die from smoking",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Will+half+the+Chinese+male+population+die+from+smoking.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Will+half+the+Chinese+male+population+die+from+smoking.MP4",
      },
      {
        id: 35,
        title: "Your trash can save your wallet and the planet",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+trash+can+save+your+wallet+and+the+planet.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+trash+can+save+your+wallet+and+the+planet.MP4",
      },
      {
        id: 36,
        title: "Your worst habits could mean you re the next Einstein",
        images_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+worst+habits+could+mean+you+re+the+next+Einstein.jpeg",
        video_url:
          "http://cdn.game-lords.com/Batch+2/gmn-video/Technology/Your+worst+habits+could+mean+you+re+the+next+Einstein.MP4",
      },
    ],
  },
  {
    id: 15,
    category_name: "Tiktok Tips & Tricks",
    data: [
      {
        id: 1,
        title: "How to get started on TikTok Tips and Tricks for 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+to+get+started+on+TikTok+Tips+and+Tricks+for+2021.mp4",
      },
      {
        id: 2,
        title: "How To Skyrocket TikTok GROWTH in 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/How+To+Skyrocket+TikTok+GROWTH+in+2021.mp4",
      },
      {
        id: 3,
        title: "Tiktok Mistakes To STOP Doing in 2021",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tiktok+Mistakes+To+STOP+Doing+in+2021.mp4",
      },
      {
        id: 4,
        title: "Tips To Grow FASTER on TikTok",
        images_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/Tiktok+Tips+%26+Tricks/Tips+To+Grow+FASTER+on+TikTok.mp4",
      },
    ],
  },
];

export const videos_cz = [
  {
    id: 1,
    category_name: "WhatsApp and Viber Tips & Tricks",
    data: [
      {
        id: 101,
        title: "7 SECRET WhatsApp Tips, Tricks, and Hacks",
        images_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/7+SECRET+WhatsApp+Tips%2C+Tricks%2C+and+Hacks.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/7+SECRET+WhatsApp+Tips%2C+Tricks%2C+and+Hacks.mp4",
      },
      {
        id: 102,
        title: "How to Use Viber",
        images_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/How+to+Use+Viber.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/How+to+Use+Viber.mp4",
      },
      {
        id: 103,
        title: "WhatsApp TIPS, TRICKS & HACKS",
        images_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+TIPS%2C+TRICKS+%26+HACKS.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+TIPS%2C+TRICKS+%26+HACKS.mp4",
      },
      {
        id: 104,
        title: "WhatsApp Tricks and Tips 2022",
        images_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+Tricks+and+Tips+2022.jpeg",
        video_url:
          "https://cdn.game-lords.com/Batch+2/WhatsApp+and+Viber+Tips+%26+Tricks/WhatsApp+Tricks+and+Tips+2022.mp4",
      },
    ],
  },
];

let st_idx = 0;
export const videos_za = [
  ...videos_kw,
  videos_qa[0],
  videos_gmn[1],
  videos_gmn[3],
  videos_gmn[7],
  ...videos_za_ci,
  {
    id: 1,
    category_name: "Squid Game",
    data: [
      {
        id: 1,
        title: "How To Beat Every DEATH GAME In  SQUID GAME",
        images_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/How+To+Beat+Every+DEATH+GAME+In++SQUID+GAME.jpeg",
        video_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/How+To+Beat+Every+DEATH+GAME+In++SQUID+GAME.mp4"
      },
      {
        id: 2,
        title: "Squid Game 15 Things You Missed",
        images_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/Squid+Game+15+Things+You+Missed.jpeg",            
        video_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/Squid+Game+15+Things+You+Missed.mp4"    
      },
      {
        id: 3,
        title: "SQUID GAME Breakdown Every Easter Egg, Clue, Hidden Detail & Ending Explained",
        images_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Breakdown+Every+Easter+Egg%2C+Clue%2C+Hidden+Detail+%26+Ending+Explained.jpeg",
        video_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Breakdown+Every+Easter+Egg%2C+Clue%2C+Hidden+Detail+%26+Ending+Explained.mp4"
      },
      {
        id: 4,
        title: "SQUID GAME Ending Every Clue About Il-Nam   Things You Missed And Hidden Details",
        images_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Ending+Every+Clue+About+Il-Nam+++Things+You+Missed+And+Hidden+Details.jpeg",
        video_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/SQUID+GAME+Ending+Every+Clue+About+Il-Nam+++Things+You+Missed+And+Hidden+Details.mp4"
      },
      {
        id: 5,
        title: "Sugar Honeycomb - Squid Game No Blood (PG-13) Dalgona Candy",
        images_url:
            "https://cdn.game-lords.com/Batch+2/Squid+Game/Sugar+Honeycomb+-+Squid+Game+No+Blood+(PG-13)+Dalgona+Candy.jpeg",
        video_url: 
            "https://cdn.game-lords.com/Batch+2/Squid+Game/Sugar+Honeycomb+-+Squid+Game+No+Blood+(PG-13)+Dalgona+Candy.mp4"
      }
    ],
  },
].map((item, idx) => {
  const new_data = item.data.map((i, eidx) => ({
    ...i,
    id: st_idx + eidx + 1,
  }));
  st_idx = st_idx + new_data.length;
  return { ...item, id: idx + 1, data: new_data };
});


// WEBPACK FOOTER //
// ./src/constants/videos.js